export const TOP_WINNERS = 'top-winners';

// region Component Preferences

export const PERIOD = Object.freeze({
    LAST_DAY: '1',
    LAST_WEEK: '7',
    LAST_MONTH: '30'
});

export const VIEW = Object.freeze({
    CAROUSEL: 'carousel',
    TABLE: 'table',
    LINE: 'line'
});

export const WINNER_INFO = Object.freeze({
    INITIALS: 'initials',
    NICKNAME: 'nickname'
});

// endregion

// region Carousel

export const CAROUSEL_SLIDER_OPTIONS = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: { enabled: false },
        buttons: { enabled: false }
    }
};

export const CAROUSEL_MIN_ITEMS_PER_SLIDE = 2;

export const CAROUSEL_ITEM_MIN_WIDTH = 200;

// endregion

// region Table

export const TABLE_ANIMATION_INTERVAL = 4000;

// in rem
export const TABLE_ITEM_HEIGHT = {
    DESKTOP: 9.6,
    MOBILE: 5.6
};

// endregion

// region Line

export const LINE_ANIMATION_SPEED = 50;

// endregion
